export const IndeterminateProgress = () => (
  <div className="pointer-events-none w-full">
    <div className="h-0.5 w-full overflow-hidden">
      <div className="animate-progress h-full w-full origin-left bg-blue-500" />
    </div>
  </div>
);
